import { Component, computed, input } from '@angular/core';
import { Dialog } from '@shared/components/dialog/dialog';
import { RouterOutlet } from '@angular/router';

/**
 * Cornice a finestra del dettaglio attività: avvolge il contenuto proiettato in un `ta-dialog` sempre visibile. In popup
 * fissa la misura della finestra, sulla rotta primaria massimizza a piena pagina. La chiusura non passa di qui:
 * la governa l'azzeramento dell'outlet. Il corpo arriva per proiezione dentro il `#bodyTemplate`, così
 * salta il riquadro con padding del corpo di default e la scheda resta a tutto bordo.
 */
@Component({
  selector: 'ta-job-detail-dialog-shell',
  template: `
    <ta-dialog
      [dialogCssClass]="this.dialogCssClass()"
      [maximize]="!this.outletModal()"
      [showHeader]="false"
      [visible]="true"
    >
      <ng-template #bodyTemplate>
        <router-outlet />
      </ng-template>
    </ta-dialog>
  `,
  imports: [Dialog, RouterOutlet]
})
export class JobDetailDialogShell {
  // Parametri provenienti dalla rotta
  public readonly outletModal = input(false);

  public readonly dialogCssClass = computed(() => (this.outletModal() ? 'size-full lg:h-240 lg:w-360' : 'max-w-full'));
}
